import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useMediaQuery, BREAKPOINTS } from '../../../hooks/useMediaQuery';
import inquiryBannerDesktop from '../../../assets/images/inquiry_banner_desktop.jpg';
import inquiryBannerMobile from '../../../assets/images/inquiry_banner_mobile.jpg';

const InquiryBannerSection = () => {
    const isTablet = useMediaQuery(BREAKPOINTS.TABLET);
    const isMobile = useMediaQuery(BREAKPOINTS.MOBILE);
    const { ref: sectionRef, inView } = useInView({
        threshold: 0.5,
        triggerOnce: false,
    });
    return (
        <section ref={sectionRef} className="relative w-full">
            <div className="relative">
                {isMobile || isTablet ? (
                    <div className="relative">
                        <img src={inquiryBannerMobile} alt="Inquiry Banner" className="w-full" />
                        <div className="absolute inset-0 bg-black/40 flex flex-col justify-center items-center text-white">
                            <h2 className={`font-bold mb-4 tablet:text-display-large text-headline-medium ${inView ? 'animate-fadeSlideUp' : ''}`}>입학문의</h2>
                            <p className={`text-center px-4 tablet:text-headline-medium text-title-small tablet:leading-[50px] ${inView ? 'animate-fadeSlideUp delay-500' : ''}`}>
                                아나톨레 어학원은<br />
                                쉽고 효과적으로 영어를 배울 수 있도록 설계된<br />
                                맞춤형 영어 학습 전문 학원입니다.
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="relative">
                        <img src={inquiryBannerDesktop} alt="Inquiry Banner" className="w-full" />
                        <div className="absolute inset-0 bg-black/30 flex flex-col justify-center items-center text-white">
                            <h2 className={`font-bold mb-6 text-display-large ${inView ? 'animate-fadeSlideUp' : ''}`}>입학문의</h2>
                            <p className={`text-center text-headline-medium leading-[50px] ${inView ? 'animate-fadeSlideUp delay-500' : ''}`}>
                                아나톨레 어학원은<br />
                                쉽고 효과적으로 영어를 배울 수 있도록 설계된<br />
                                맞춤형 영어 학습 전문 학원입니다.
                            </p>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default InquiryBannerSection;



